/**
*
* RedPartners
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import selectCompanieById from 'helpers/selectCompanieById';
import formatWww from 'helpers/formatWww';
import Wrapper from 'components/Templates/dynamics/Wrapper';

import defaultTextValues from './defaultTextValues';

class RedPartners extends React.Component {


  render() {

      const {
        commonData,
        openEditor,
        commonProps,
        companies,
        setShowPopup
      } = this.props;

      const {
        isEditor,
        helpers
      } = commonProps;

      const {
        componentPayload
      } = commonData;

      const {
        companyLogoType,
        sectionId
      } = componentPayload;

      const thisPartnersList = componentPayload && componentPayload.companies ? componentPayload.companies : '';

      const thisCompanyLogoType = companyLogoType ? companyLogoType : 'colorLogo';

      const sponsorsContent = thisPartnersList && thisPartnersList.length > 0 ? thisPartnersList.map((company) => {

        const thisCompany = selectCompanieById(companies, company);
        if (!thisCompany) return;
        
        const {
          website
        } = thisCompany;
        const formatWebsite = formatWww(website);

        return thisCompanyLogoType && thisCompany && thisCompany[thisCompanyLogoType] ? (
          <Wrapper
            {...commonProps}
            key={'RedPartnersCompany-'+company+sectionId}
            
            typeOfStyle={'companyLogoContainer'}
            href={formatWebsite && formatWebsite.href ? formatWebsite.href : null}
            target={'_blank'}
            editorData={
              {
                editorType: 'companyLogoContainer',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'companyLogo'}
              backgroundImage={thisCompany[thisCompanyLogoType]}
              editorData={
                {
                  editorType: 'companyLogo',
                  ...commonData
                }
              }
            />
          </Wrapper>
        ) : '';


      }) : '';


      return (
        <Wrapper
          {...commonProps}
          addDataContent={isEditor ? {
            editorData: {
              editorType: 'wrapper',
              ...commonData
            },
            helpers: helpers,
            setShowPopup: setShowPopup,
            popupValue: 'companies-view',
            title: 'Manage Partners'
          } : ''}
          typeOfStyle={'wrapper'}
          editorData={
            {
              editorType: 'wrapper',
              ...commonData
            }
          }
        >
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'wrapperWithMargin'}
            editorData={
              {
                editorType: 'wrapperWithMargin',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'title'}
              defaultValues={defaultTextValues}
              type={'text'}
              editorData={
                {
                  editorType: 'title',
                  ...commonData
                }
              }
            />
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'paragraph'}
              type={'text'}
              editorData={
                {
                  editorType: 'paragraph',
                  ...commonData
                }
              }
            />
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'sponsorsWrapper'}
              editorData={
                {
                  editorType: 'sponsorsWrapper',
                  ...commonData
                }
              }
            >
              {sponsorsContent}
            </Wrapper>
            
          </Wrapper>
        </Wrapper>
      );

  }

}

RedPartners.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  companies: PropTypes.array,
  setShowPopup: PropTypes.func,
};

export default RedPartners;
